module.exports = __webpack_public_path__ + "static/media/swipeRight.bcb1d0eb.png";